<header id="page-topbar" [style.display]="headLess ? 'none' : 'block'">
  <div class="navbar-header">
    <div class="d-flex align-items-center">
      <ng-container *ngIf="communityService.model$ | async as community">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a
            [routerLink]="['/communities', community.id]"
            class="logo logo-dark">
            <span class="logo-sm">
              <img
                src="assets/images/brands/tsolife-ico-250x250.svg"
                alt=""
                height="22" />
            </span>
            <span class="logo-lg">
              <img
                [src]="
                  community.logoMedia?.url
                    ? community.logoMedia?.url
                    : community.corporation.logoMedia?.url ??
                      'assets/images/brands/tsolife-logo-200x45.svg'
                "
                alt=""
                height="35" />
            </span>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          (click)="toggleMenubar()">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="d-none d-sm-inline-block">
          <div class="">Community Portal</div>
          <div class="fw-bold" *ngIf="community">
            <a [routerLink]="['/communities', community.id, 'analytics']">
              {{ community.name }}
              <span *ngIf="community.code"> | {{ community.code }}</span>
            </a>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="d-flex">
      <app-search></app-search>

      <div class="dropdown d-inline-block d-lg-none me-2" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-search-dropdown"
          ngbDropdownToggle>
          <i class="mdi mdi-magnify"></i>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          ngbDropdownMenu>
          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username" />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          ngbDropdownToggle>
          <i class="bx bx-bell"></i>
          <span class="badge bg-danger rounded-pill">0</span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ 'HEADER.NOTIFICATIONS.TITLE' | translate }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="javascript: void(0);" class="small">{{
                  'HEADER.NOTIFICATIONS.VIEW_ALL' | translate
                }}</a>
              </div>
            </div>
          </div>

          <app-ngx-simplebar style="position: relative; height: 230px">
          </app-ngx-simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ 'HEADER.NOTIFICATIONS.LOAD_MORE' | translate }}
            </a>
          </div>
        </div>
      </div>

      <app-global-downloads></app-global-downloads>

      <app-page-header-user-dropdown></app-page-header-user-dropdown>
    </div>
  </div>
</header>

<div class="topnav" [style.display]="headLess ? 'none' : 'block'">
  <nav class="navbar navbar-expand-lg topnav-menu">
    <div class="container-fluid">
      <div id="topnav-menu-pages" class="collapse navbar-collapse">
        <ul class="navbar-nav me-auto">
          <ng-container *ngFor="let item of menuItems">
            <li
              class="nav-item dropdown"
              *ngIf="!hideSubMenuOptions.includes(item.label)">
              <a
                id="topnav-components"
                class="nav-link"
                [ngClass]="{ 'dropdown-toggle arrow-none': hasItems(item) }"
                href="javascript: void(0);"
                (click)="onMenuClick($event, item)"
                [routerLink]="item.link"
                role="button">
                <i class="bx {{ item.icon }} me-2"></i>
                {{ item.label | translate }}
                <div class="arrow-down" *ngIf="hasItems(item)"></div>
              </a>
              <div
                class="dropdown-menu"
                aria-labelledby="topnav-dashboard"
                *ngIf="hasItems(item)">
                <ng-template
                  ngFor
                  let-i="index"
                  let-subitem
                  [ngForOf]="item.subItems">
                  <a
                    *ngIf="
                      !hasItems(subitem) &&
                      !hideSubMenuOptions.includes(subitem.label)
                    "
                    class="col dropdown-item side-nav-link-ref"
                    [routerLink]="subitem.link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    {{
                      subitem.label.toUpperCase() === 'CALENDAR' && brookdaleInd
                        ? 'Engagement Worksheet'
                        : (subitem.label | translate)
                    }}
                  </a>

                  <div class="dropdown" *ngIf="hasItems(subitem)">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="javascript: void(0);"
                      (click)="onMenuClick($event)">
                      {{ subitem.label | translate }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <ng-template
                        ngFor
                        let-subSubitem
                        [ngForOf]="subitem.subItems">
                        <a
                          class="dropdown-item side-nav-link-ref"
                          *ngIf="
                            !hasItems(subSubitem) &&
                            !hideSubMenuOptions.includes(subitem.label)
                          "
                          href="javascript: void(0);"
                          [routerLink]="subSubitem.link"
                          routerLinkActive="active">
                          {{ subSubitem.label | translate }}
                        </a>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </nav>
</div>
